module.exports = __webpack_public_path__ + "img/img-14.fe943be6.png";